import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { Mapper, MapperParams } from '@products/utils/mappers/type.mapper';
import {
  ElapsedTimeDTO,
  PensionShortfallDTO,
  PeriodDTO,
  RequiredSavingDTO,
  ShortfallClosureResultDTO,
} from '../dto/shortfall-closure-calculator.dto.types';
import { GermanCalculatorResult } from '../model/german-calculator';
import {
  ShortfallClosureElapsedTime,
  ShortfallClosurePensionShortfall,
  ShortfallClosurePeriod,
  ShortfallClosureRequiredSaving,
  ShortfallClosureResult,
} from '../model/pension-calculator';

export class ShortfallClosureMapper extends Mapper<GermanCalculatorResult> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    shortfallClosureResultDTO: ShortfallClosureResultDTO
  ): ShortfallClosureResult {
    return {
      status: shortfallClosureResultDTO.Status,
      requiredSaving: this.createMapper(
        ShortfallClosureRequiredSavingMapper
      ).toDomain(shortfallClosureResultDTO.RequiredSaving),
      pensionShortfall: this.createMapper(
        ShortfallClosurePensionShortfallMapper
      ).toDomain(shortfallClosureResultDTO.PensionShortfall),
    };
  }
}

export class ShortfallClosurePensionShortfallMapper extends Mapper<ShortfallClosurePensionShortfall> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    pensionShortfallDTO: PensionShortfallDTO
  ): ShortfallClosurePensionShortfall {
    return {
      periods: pensionShortfallDTO.Periods.map((saving) =>
        this.createMapper(ShortfallClosurePeriodMapper).toDomain(saving)
      ),
      requiredBalance: pensionShortfallDTO.RequiredBalance,
      paymentDuration: pensionShortfallDTO.PaymentDuration,
    };
  }
}

export class ShortfallClosureRequiredSavingMapper extends Mapper<ShortfallClosureRequiredSaving> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    requiredSavingDTO: RequiredSavingDTO
  ): ShortfallClosureRequiredSaving {
    return {
      periods: requiredSavingDTO.Periods.map((saving) =>
        this.createMapper(ShortfallClosurePeriodMapper).toDomain(saving)
      ),
      instalmentAmount: requiredSavingDTO.InstalmentAmount,
      interestRate: requiredSavingDTO.InterestRate,
      savingDuration: requiredSavingDTO.SavingDuration,
    };
  }
}

export class ShortfallClosurePeriodMapper extends Mapper<ShortfallClosurePeriod> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(periodResult: PeriodDTO): ShortfallClosurePeriod {
    return {
      elapsedTime: this.createMapper(
        ShortfallClosureElapsedTimeMapper
      ).toDomain(periodResult.ElapsedTime),
      finalBalance: periodResult.FinalBalance,
      initialBalance: periodResult.InitialBalance,
    };
  }
}

export class ShortfallClosureElapsedTimeMapper extends Mapper<ShortfallClosureElapsedTime> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(periodResult: ElapsedTimeDTO): ShortfallClosureElapsedTime {
    return {
      years: periodResult.Years,
      days: periodResult.Days,
    };
  }
}
